import RichTextElement from "@/app/(site)/_components/GCMolecules/RichTextElement"
import { type CheckoutPageSettingsContent } from "@/types"

interface NotificationBarProps {
    params: { locale: string }
    notificationBar: CheckoutPageSettingsContent["notificationBar"]
}

export default function NotificationBar({
    params,
    notificationBar
}: NotificationBarProps) {
    return (
        <div className="mb-24 bg-muted p-16">
            <RichTextElement
                richTextGroup={notificationBar?.text}
                className="!Trade_Gothic_Text_14_150_0_300"
            />
        </div>
    )
}
